import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import sidom from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";
import E1E from "../assets/images/sidom/svg/luna_new.svg";
import "../../node_modules/react-modal-video/css/modal-video.css";

export default function About(data) {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  // Validación para evitar error si data o data.data es undefined
  const aboutData =
    Array.isArray(data?.data) && data.data[0] ? data.data[0] : {};
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <>
      <div className=" bg-gradient-to-t from-sidom-blue via-sidom-blue to-sidom-orange ">
        <div data-aos="fade-up" data-aos-delay="100" className="container ">
          <div className="flex  items-center mb-8  px-2 md:px-0 lg:px-0text-right">
            <img
              src={
                aboutData?.logo?.formats?.thumbnail?.url
                  ? `${urlApi}${aboutData.logo.formats.thumbnail.url}`
                  : sidom
              }
              className="w-[300px] "
              alt="Logo institucional de Sidom"
            />
          </div>

          <div className="flex flex-col justify-center mt-8 items-center  px-2 md:px-0 lg:px-0 text-sidom-light">
            <div className="flex flex-col text-xs sm:text-sm md:text-base lg:text-xl text-left leading-relaxed   ">
              {Array.isArray(aboutData?.descripcion)
                ? aboutData.descripcion.map((bloque, idx) => {
                    const type = bloque.type || "paragraph";
                    let Tag = "p";
                    let className = "";
                    if (type === "heading1") {
                      Tag = "h1";
                      className = "text-3xl md:text-4xl font-bold mb-2";
                    } else if (type === "heading2") {
                      Tag = "h2";
                      className = "text-2xl md:text-3xl font-bold mb-2";
                    } else if (type === "heading3") {
                      Tag = "h3";
                      className = "text-xl md:text-2xl font-bold mb-2";
                    } else if (type === "paragraph") {
                      Tag = "p";
                      className = "mb-4";
                    }
                    return (
                      <Tag key={idx} className={className}>
                        {Array.isArray(bloque.children)
                          ? bloque.children.map((c, i) => {
                              let style = "";
                              if (c.bold) style += " font-bold";
                              if (c.italic) style += " italic";
                              if (c.underline) style += " underline";
                              if (c.size === "large")
                                style += " text-xl md:text-2xl";
                              if (c.size === "medium")
                                style += " text-base md:text-lg";
                              if (c.size === "small") style += " text-sm";
                              return (
                                <span key={i} className={style.trim()}>
                                  {c.text}
                                </span>
                              );
                            })
                          : null}
                      </Tag>
                    );
                  })
                : null}
            </div>

            <div className="flex justify-center  mt-[65px] mb-[100px] items-center w-full  ">
              <img
                src={
                  aboutData?.img?.url ? `${urlApi}${aboutData.img.url}` : E1E
                }
                className="w-[70%]"
                alt="Gráfico decorativo media luna"
              />
            </div>
            <div className="w-full flex justify-center items-center">
              <div className="container border-b-[1px] border-white"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
